import { useState } from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import NotificationBell from '../Notifications/NotificationBell';
import Footer from '../Footer/Footer';

const Layout = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [logoutLoading, setLogoutLoading] = useState(false);

  const handleLogout = async () => {
    setLogoutLoading(true);

    try {
      await logout();
      navigate('/login', { state: { fromLogout: true } });
    } catch (error) {
      console.error('Logout error:', error);
      // Even if the API call fails, clear local session and send user to login
      navigate('/login', { state: { fromLogout: true } });
    } finally {
      setLogoutLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {isAuthenticated && (
        <nav className="bg-white shadow-sm border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between h-16">
              <div className="flex items-center space-x-8">
                <Link to="/dashboard" className="text-2xl font-bold text-primary-600">
                  ALIEN GREEN (EduTechnologies)
                </Link>
                <nav className="hidden md:flex space-x-4">
                  <Link to="/dashboard" className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium">
                    Dashboard
                  </Link>
                  {user?.role !== 'instructor' && (
                    <>
                      <Link to="/content" className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium">
                        Content
                      </Link>
                      <Link to="/exams" className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium">
                        Exams
                      </Link>
                      <Link to="/progress" className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium">
                        Progress
                      </Link>
                      <Link to="/reports" className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium">
                        Reports
                      </Link>
                    </>
                  )}
                  {user?.role === 'instructor' && user?.instructor_status === 'approved' && (
                    <>
                      <Link to="/my-content" className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium">
                        My Content
                      </Link>
                      <Link to="/my-exams" className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium">
                        My Exams
                      </Link>
                      <Link to="/instructor/earnings" className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium">
                        Earnings
                      </Link>
                      <Link to="/reports" className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium">
                        Reports
                      </Link>
                    </>
                  )}
                  <Link to="/payment" className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium">
                    Buy Coins
                  </Link>
                </nav>
              </div>
              <div className="flex items-center space-x-4">
                {user?.coins_balance !== undefined && (
                  <div className="flex items-center space-x-2 bg-yellow-50 border border-yellow-200 rounded-lg px-3 py-1.5">
                    <span className="text-yellow-600 font-bold text-lg">🪙</span>
                    <span className="text-yellow-800 font-semibold">{user.coins_balance}</span>
                    <span className="text-yellow-600 text-sm">coins</span>
                  </div>
                )}
                <NotificationBell />
                <Link to="/profile" className="text-sm text-gray-700 hover:text-primary-600">
                  {user?.name}
                </Link>
                <button
                  onClick={handleLogout}
                  className="btn btn-secondary text-sm flex items-center gap-2"
                  disabled={logoutLoading}
                >
                  {logoutLoading && (
                    <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  )}
                  <span>{logoutLoading ? 'Logging out...' : 'Logout'}</span>
                </button>
              </div>
            </div>
          </div>
        </nav>
      )}
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
